
/**
 * 알림 대상 정보
 */
export type UpdateNotificationReadStatus200Target = {
  /** 알림 대상 객체 ID (트윗 ID 등) */
  targetId?: number;
  /** 알림 대상 객체 유형 (TWEET, USER 등) */
  targetType?: string;
};
